module.exports = __webpack_public_path__ + "img/ezGolf-icon-tour.57336a50.svg";